import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {fetchDataIfReady, setAlert} from '../modules/fetch.action.js'
import {handleChange, areFieldsNotEmpty, areFieldsValid, sanitizePayload} from '../modules/functions.js'
import ModalWrapper from '../components/Modal_Wrapper.js'
import icon_trash from '../images/icon-trash.svg';

const e = React.createElement;


function ModalCRUD(props) {
  React.Component.constructor.call(this);

  var workspace_id = (typeof props.workspace_id !== 'undefined') ? props.workspace_id : null;
  var api_block = (typeof props.workspace_id !== 'undefined') ? props.api_block+"_"+props.workspace_id : props.api_block;

  this.state = {nw_name:"", workspace_id:workspace_id, api_block:api_block}; // todo: nw_name moet op een manier generieker
}
ModalCRUD.prototype = Object.create(React.Component.prototype);

ModalCRUD.prototype.render = function() {
  if(this.props.shouldShow) {
    var create_form = null, current_data = null, api_data = this.props.apiData[this.state.api_block];

    if(api_data && api_data.isValid) {
      if(this.props.create) {
        create_form = e('form', {key:"form", onSubmit:function(e) {this.handleCreate(e)}.bind(this)}, [
          e('br', {key:"br1"}),
          e('div', {key:"input1"}, e('input', {key:"name", type:"text", value:this.state.nw_name, onChange:handleChange.bind(null, this, "nw_name"), placeholder:this.props.main_property})),
          e('div', {key:"submit"}, e('input', {type:"submit", value:"opslaan", disabled:this.props.label_create_is_fetching})),
        ]);
      }
      if(api_data.data[0]) {
        current_data = api_data.data.map(function(item, i) {
          var data_count = null, data_count_html = null, delete_btn = null;
          if(this.props.api_block_counts) {
            var ext_api_data = this.props.apiData[this.props.api_block_counts+api_data.data[i].id];
            data_count = (ext_api_data) ? ext_api_data.data.length : "-";
            data_count_html = e('div', {key:"31_"+i+"_"+item.id, style:{display:"inline-block", marginRight:"7px"}}, data_count);
          }
          if(this.props.delete) {
            var btn_active = false;
            if(typeof this.props.api_block_counts === 'undefined' || data_count === 0) {
              if(typeof this.props.reserved_keyword === 'undefined' || this.props.reserved_keyword !== item[this.props.main_property]) {
                btn_active = true;
              }
            }
            var opacity = (btn_active) ? null : ".5";
            var btn = null;
            if(btn_active) {
              var btn = e('img', {src:icon_trash, alt:"Delete", onClick:function() {this.handleDelete(item.id)}.bind(this)});
            } else {
              var btn = e('img', {src:icon_trash, alt:"Inactive"});
            }
            delete_btn = e('div', {key:"32_"+i+"_"+item.id, className:"card-actions", style:{opacity:opacity}}, btn);
          }
          var display_title = item[this.props.main_property];
          if(this.props.main_property_formatting) display_title = this.formatText(display_title, this.props.main_property_formatting);
          if(this.props.api_block_ref && this.props.api_block_ref_id && this.props.ref_main_property) {
            var found_ref_item = this.props.apiData[this.props.api_block_ref].data.find(function(ref_item) {
              return ref_item.id === item[this.props.api_block_ref_id];
            }.bind(this));
            display_title += " "+found_ref_item[this.props.ref_main_property];
          }
          if(this.props.sub_property) {
            var display_subtitle = item[this.props.sub_property];
            if(this.props.sub_property_formatting) display_subtitle = this.formatText(display_subtitle, this.props.sub_property_formatting);
            var display_subtitle = "("+display_subtitle+")";
            display_title = e('div', {key:"2_1_"+i+"_"+item.id, className:"card-layout"}, [
              e('span', {key:"2_1_1_"+i+"_"+item.id, style:{marginRight:"7px"}}, display_title),
              e('small', {key:"2_1_2_"+i+"_"+item.id, style:{opacity:".6"}}, display_subtitle)
            ]);
          }
          return e('div', {key:"1_"+i+"_"+item.id, className:"card-layout"}, [
            e('div', {key:"2_"+i+"_"+item.id, className:"card-layout-div85"}, display_title),
            e('div', {key:"3_"+i+"_"+item.id, className:"card-layout-div15", style:{textAlign:"right"}}, [
              data_count_html,
              delete_btn
            ]),
          ]);
        }.bind(this));
      } else {
        current_data = e('div', null, this.props.empty_text);
      }
    }

    return e(ModalWrapper, {switchState:this.props.close}, [
      e('div', {key:"current_data", className:"table-style"}, current_data),
      this.props.create && create_form,
      e('i', {key:"hotkey", id:"modal-crud-hook"})
    ]);
  } else {
    return null;
  }
}

ModalCRUD.prototype.formatText = function(txt, txt_format) {
  if(txt_format === "kg") {
    return txt.toString().replace(".", ",")+" kg";
  } else if(txt_format === "g") {
    return txt.toString().replace(".", ",")+"g";
  } else if(txt_format === "date_d-ml-y") {
    var d = new Date(txt);
    return d.getDate()+" "+d.toLocaleString('default', { month: 'long' })+" "+d.getFullYear();
  } else {
    return txt;
  }
}

ModalCRUD.prototype.handleCreate = function(e) {
  e.preventDefault();
  var payload = {name:this.state.nw_name};
  if(this.state.workspace_id) payload["workspace_id"] = this.state.workspace_id;
  if(typeof this.props.reserved_keyword !== 'undefined' && this.props.reserved_keyword === payload.name) {
    this.props.setAlert("Ongeldig: mag maar één lijst met naam \""+this.props.reserved_keyword+"\"."); // todo: i18n
    return;
  }
  if(areFieldsNotEmpty(this.props.required_fields, payload, this.props.setAlert) && areFieldsValid(this.props.validate_fields, payload, this.props.setAlert)) {
    if(this.props.label_create_is_fetching === false || this.props.label_create_is_fetching === null) { // todo: this never activates :)
      payload = sanitizePayload(this.props.validate_fields, payload);
      this.props.fetchDataIfReady(this.props.config.api_token, this.state.api_block, "POST", this.props.config.api_url+this.props.api_endpoint_create+"?t="+this.props.session_token, JSON.stringify(payload), null, true, false, true, false, false, null, this.state.api_block);
      this.setState({nw_name:""});
    }
  }
  return false;
}

ModalCRUD.prototype.handleDelete = function(item_id) {
  var payload = {session_token:this.props.session_token, id:item_id};
  this.props.fetchDataIfReady(this.props.config.api_token, "bin", "DELETE", this.props.config.api_url+this.props.api_endpoint_delete, JSON.stringify(payload), null, true, false, true, false, false, null, this.state.api_block);
  return false;
}


function mapStateToProps(state) {
  var session_token = null, label_create_is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["label_create"] !== undefined && state.apiData["label_create"].isFetching !== undefined) {
    label_create_is_fetching = state.apiData["label_create"].isFetching; // todo: generiek :)
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    label_create_is_fetching: label_create_is_fetching,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCRUD)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalCRUD.js
// module id = 98
// module chunks = 0